<div class="od-root" [class.dark]="isDark()">

  <header class="od-topbar">

    <div class="od-topbar-left">
      <!-- Back to Dashboard -->
      <button class="od-back-btn" (click)="goBack()" title="Back to Dashboard">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>

      <!-- Section / Machine-type tabs -->
      <nav class="od-tabs">
        @for (tab of filteredMachineTypes(); track tab.id) {
        <button class="od-tab" [class.active]="activeTab()?.id === tab.id" (click)="selectTab(tab)">
          {{ tab.machineTypeName }}
        </button>
        }
      </nav>
    </div>

    <!-- Right controls -->
    <div class="od-topbar-right">

      <span class="od-label"
        style="margin-right: 12px; font-size: 13px; color: var(--text-muted); display: flex; align-items: center; gap: 4px;">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
        Updated: {{ lastUpdatedTime() }}
      </span>

      <!-- Dark mode toggle -->
      <button class="od-theme-btn" (click)="isDark.set(!isDark())" [title]="isDark() ? 'Light mode' : 'Dark mode'">
        @if (isDark()) {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="5" />
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
        } @else {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
        }
      </button>

      <!-- DEPARTMENT label + select -->
      <div class="od-dept-group">
        <span class="od-label">DEPARTMENT:</span>
        <select [ngModel]="departmentId()" (ngModelChange)="onDepartmentChange(+$event)"
          [disabled]="allowedContext() !== null" class="od-select">
          @for (dept of visibleDepartments(); track dept.departmentId) {
          <option [ngValue]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
          }
        </select>
      </div>
    </div>
  </header>

  <!-- ═══════════════════════════════════════════════════════════════════════ -->
  <!-- DIECUT SPLIT LAYOUT                                                    -->
  <!-- ═══════════════════════════════════════════════════════════════════════ -->
  @if (isDiecut()) {

  <!-- ── Shared date bar for both diecut panels ────────────────────────── -->
  <div class="od-page-header od-diecut-header">
    <div>
      <div style="display: flex; align-items: center; gap: 12px; margin-bottom: -2px;">
        <h1 class="mc-dash-machine-name">DIE-CUT OPERATIONAL DASHBOARD</h1>
      </div>
      <div class="flex gap-4">
        <div style="display: flex; gap: 16px; font-size: 13px; color: var(--text-muted, #888);">
          <span style="display: flex; align-items: center; gap: 4px;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            {{ selectedDate() }}
          </span>
          <span style="display: flex; align-items: center; gap: 4px;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            {{ currentTime }}
          </span>
        </div>
      </div>
    </div>

    <div class="od-date-controls">
      <div class="od-date-group">
        <span class="od-label">DATE</span>
        <input type="date" [ngModel]="selectedDate()" (ngModelChange)="onDateChange($event)"
          class="od-select od-select-sm" style="min-width: 130px; font-family: inherit;">
      </div>
    </div>
  </div>

  <!-- ── Two-panel split container ─────────────────────────────────────── -->
  <div class="mc-diecut-split">

    <!-- ═══════════════ LEFT PANEL – Machine 1 ═══════════════ -->
    <div class="mc-diecut-panel mc-diecut-panel--left">

      <!-- Panel header -->
      <div class="mc-diecut-panel-header">
        <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
          <h2 class="mc-dash-machine-name" style="font-size: 20px;">{{ selectedMachineName() | uppercase }}</h2>
          <span class="mc-dash-status-badge" [class.mc-status-operational]="machineStatus() === 'operational'"
            [class.mc-status-make-ready]="machineStatus() === 'make ready'"
            [class.mc-status-idle]="machineStatus() === 'idle'" [class.mc-status-hold]="machineStatus() === 'hold'"
            [class.mc-status-maintenance]="machineStatus() === 'maintenance'">
            {{ (machineStatus() || 'UNKNOWN') | uppercase }}
          </span>
          <span *ngIf="realtimeShiftName()" class="mc-dash-status-badge"
            style="border: 1.5px solid #cbd5e1; color: #475569; background: rgba(203, 213, 225, 0.2);">
            {{ realtimeShiftName() | uppercase }} - {{ liveShiftDate() || selectedDate() }}
          </span>
        </div>
      </div>

      <!-- ── KPI Cards Row ────────────────────── -->
      <div class="mc-content">
        <div class="mc-dashboard">

          <div class="mc-kpi-row">

            <!-- Daily Goal Achievement -->
            <div class="mc-kpi-card mc-goal-card" [class.exceeded-blink]="machineStatus() === 'make ready' && isTimerExceeded(makeReadyTimerStr())">
              <div class="mc-goal-title">Daily Goal Achievement</div>
              <div class="mc-goal-body mc-goal-body--centered">
                <div class="mc-donut-wrap">
                  <svg viewBox="0 0 80 80" class="mc-donut">
                    <circle cx="40" cy="40" r="32" class="mc-donut-track" />
                    <circle cx="40" cy="40" r="32" class="mc-donut-fill" stroke-dasharray="201.06"
                      [attr.stroke-dashoffset]="donutDashOffset()" transform="rotate(-90 40 40)" />
                  </svg>
                  <div class="mc-donut-center">
                    <div class="mc-donut-pct">{{ goalAchievementPct() }}%</div>
                    <div class="mc-donut-sub">Target</div>
                  </div>
                </div>

                <!-- Make Ready Timer -->
                <div *ngIf="machineStatus() === 'make ready'" class="mc-mr-timer-container" [class.exceeded]="isTimerExceeded(makeReadyTimerStr())">
                  <div class="mc-mr-timer-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span>MAKE READY TIMER</span>
                    <span class="mc-mr-timer-status-dot" [class.running]="makeReadyTimerStatus() === 'running'"
                      [class.paused]="makeReadyTimerStatus() === 'paused'" [class.exceeded]="isTimerExceeded(makeReadyTimerStr())"></span>
                  </div>
                  <div class="mc-mr-timer-val" [class.running]="makeReadyTimerStatus() === 'running'"
                    [class.paused]="makeReadyTimerStatus() === 'paused'" [class.exceeded]="isTimerExceeded(makeReadyTimerStr())">
                    {{ makeReadyTimerStr() }}
                  </div>
                </div>

                <!-- Operational Timer -->
                <div *ngIf="machineStatus() === 'operational'" class="mc-mr-timer-container">
                  <div class="mc-mr-timer-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span>OPERATIONAL TIMER</span>
                    <span class="mc-mr-timer-status-dot" [class.running]="operationalTimerStatus() === 'running'"
                      [class.paused]="operationalTimerStatus() === 'paused'"></span>
                  </div>
                  <div class="mc-mr-timer-val" [class.running]="operationalTimerStatus() === 'running'"
                    [class.paused]="operationalTimerStatus() === 'paused'">
                    {{ operationalTimerStr() }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Daily Planned -->
            <div class="mc-kpi-card">
              <div class="mc-kc-title">Daily Planned</div>
              <div class="mc-kc-value">{{ dailyPlanned() | number }}</div>
              <div class="mc-kc-sub">target {{ unitOfMachine() }}</div>
            </div>

            <!-- Daily Output -->
            <div class="mc-kpi-card">
              <div class="mc-kc-title">Daily Output</div>
              <div class="mc-kc-value mc-val-green">{{ dailyOutput() | number }}</div>
              <div class="mc-kc-sub">achieved so far</div>
              <div class="mc-mr-badge">
                <div class="mc-mr-badge-count">{{ makeReadyCount() }}</div>
                <div class="mc-mr-badge-label">MR</div>
              </div>
            </div>

            <!-- Day Shift -->
            <div class="mc-kpi-card" [class.mc-kpi-card--active]="activeShiftName()?.toLowerCase() === 'day shift'">
              <div class="mc-shift-hdr">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#f59e0b" stroke-width="2.2">
                  <circle cx="12" cy="12" r="5" />
                  <line x1="12" y1="1" x2="12" y2="3" />
                  <line x1="12" y1="21" x2="12" y2="23" />
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                  <line x1="1" y1="12" x2="3" y2="12" />
                  <line x1="21" y1="12" x2="23" y2="12" />
                </svg>
                <span class="mc-shift-name" [class.expanded]="showAllDayOps()">
                  Day Shift –
                  @if (dayShiftOperators().length === 0) {
                  Unassigned
                  } @else {
                  @if (showAllDayOps()) {
                  {{ getFirstNamesArr(dayShiftOperators()).join(', ') }}
                  <span class="mc-more-link" (click)="showAllDayOps.set(false)">(show less)</span>
                  } @else {
                  {{ getFirstNamesArr(dayShiftOperators()).slice(0, 2).join(', ') }}
                  @if (dayShiftOperators().length > 2) {
                  <span class="mc-more-link" (click)="showAllDayOps.set(true)">+{{dayShiftOperators().length - 2}}
                    more</span>
                  }
                  }
                  }
                </span>
                <span class="mc-active-badge" *ngIf="activeShiftName()?.toLowerCase() === 'day shift'">Active</span>
              </div>
              <div class="mc-kc-value">{{ dayShift()?.actualOutput || 0 | number }}</div>
              <div class="mc-kc-sub" style="color: #bb3219; font-weight: 700; font-size: 13px; margin-top: 2px;">Avg: {{
                dayShift()?.outputAveragePerHour || 0 | number:'1.0-0' }} / hr</div>
              <div class="mc-shift-mr-info">
                <span>MR Time: <strong>{{ getShiftMakeReadyTimeStr(dayShift()) }}</strong></span>
                <span class="mc-smr-dot">•</span>
                <span>Avg/MR: <strong>{{ getShiftAvgMakeReadyTimeStr(dayShift()) }}</strong></span>
              </div>
              <div class="mc-mr-badge">
                <div class="mc-mr-badge-count">{{ dayShift()?.makeReadyCount || 0 }}</div>
                <div class="mc-mr-badge-label">MR</div>
              </div>
            </div>

            <!-- Night Shift -->
            <div class="mc-kpi-card" [class.mc-kpi-card--active]="activeShiftName()?.toLowerCase() === 'night shift'">
              <div class="mc-shift-hdr">
                <span style="font-size:14px;">🌙</span>
                <span class="mc-shift-name" [class.expanded]="showAllNightOps()">
                  Night Shift –
                  @if (nightShiftOperators().length === 0) {
                  Unassigned
                  } @else {
                  @if (showAllNightOps()) {
                  {{ getFirstNamesArr(nightShiftOperators()).join(', ') }}
                  <span class="mc-more-link" (click)="showAllNightOps.set(false)">(show less)</span>
                  } @else {
                  {{ getFirstNamesArr(nightShiftOperators()).slice(0, 2).join(', ') }}
                  @if (nightShiftOperators().length > 2) {
                  <span class="mc-more-link" (click)="showAllNightOps.set(true)">+{{nightShiftOperators().length - 2}}
                    more</span>
                  }
                  }
                  }
                </span>
                <span class="mc-active-badge" *ngIf="activeShiftName()?.toLowerCase() === 'night shift'">Active</span>
              </div>
              <div class="mc-kc-value mc-val-blue">{{ nightShift()?.actualOutput || 0 | number }}</div>
              <div class="mc-kc-sub" style="color: #bb3219; font-weight: 700; font-size: 13px; margin-top: 2px;">Avg: {{
                nightShift()?.outputAveragePerHour || 0 | number:'1.0-0' }} / hr</div>
              <div class="mc-shift-mr-info">
                <span>MR Time: <strong>{{ getShiftMakeReadyTimeStr(nightShift()) }}</strong></span>
                <span class="mc-smr-dot">•</span>
                <span>Avg/MR: <strong>{{ getShiftAvgMakeReadyTimeStr(nightShift()) }}</strong></span>
              </div>
              <div class="mc-mr-badge">
                <div class="mc-mr-badge-count">{{ nightShift()?.makeReadyCount || 0 }}</div>
                <div class="mc-mr-badge-label">MR</div>
              </div>
            </div>

            <!-- ── Machine 1 Timeline ───────────── -->
            <div class="mc-card mc-timeline-card">
              <div class="mc-tl-header">
                <div class="mc-tl-title">
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  Machine Run Timeline
                  <span class="mc-tl-range" *ngIf="timelineWindow()">
                    ({{ timelineWindow()?.start }} - {{ timelineWindow()?.end }})
                  </span>
                </div>
              </div>

              <div class="mc-tl-bar">
                @for (seg of timelineSegments(); track seg) {
                <div class="mc-tl-seg {{ seg.class }}" [style.left.%]="seg.left" [style.width.%]="seg.width"
                  [title]="seg.tooltip">
                  {{ seg.label }}
                </div>
                }
              </div>

              <div class="mc-tl-axis">
                @for (tick of timelineAxis(); track tick) {
                <span>{{ tick }}</span>
                }
              </div>

              <div class="mc-tl-legend">
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-run"></span>
                  <span>Operational</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-mr"></span>
                  <span>Make Ready</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-idle"></span>
                  <span>Idle</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-hold"></span>
                  <span>Hold</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-maintenance"></span>
                  <span>Maintenance</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-heatcool"></span>
                  <span>Heat/Cool</span>
                </div>
              </div>
            </div>

          </div><!-- /mc-kpi-row -->

          <!-- ── Machine 1 Bottom Row ───────────── -->
          <div class="mc-bottom-row" [class.multiple-ops-layout]="currentOperatorPerfs().length > 1">

            <div class="mc-operator-cards-wrapper">
              @for (perf of currentOperatorPerfs(); track perf.operatorName) {
              <div class="mc-card mc-operator-card">
                <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px;">
                  <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 8px;">
                    <div style="display: flex; align-items: center; gap: 6px; padding-top: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#2563eb" stroke-width="2.5">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span style="font-size: 11px; font-weight: 800; letter-spacing: 0.05em; color: #2563eb; text-transform: uppercase;">Active Operator</span>
                    </div>
                    <div style="font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 12px; border: 1px solid #e2e8f0; color: #475569; background: #f8fafc; text-align: right;">
                      {{ liveShiftDate() || selectedDate() }}<ng-container *ngIf="realtimeShiftName()"> - {{ realtimeShiftName() | uppercase }}</ng-container>
                    </div>
                  </div>
                  <div style="font-size: 24px; font-weight: 800; color: var(--text); letter-spacing: -0.5px; line-height: 1.2; overflow-wrap: break-word;">
                    {{ perf.operatorName || 'Unassigned' }}
                  </div>
                </div>
                <div class="mc-op-table">
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Monthly OutPut</span>
                    <span class="mc-op-row-val mc-val-green">{{ perf.machineTotalOutput || 0 | number }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Avg Hourly OutPut</span>
                    <span class="mc-op-row-val mc-val-red">{{ perf.machineAvgHourlyOutput || 0 | number }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Monthly Make Ready</span>
                    <span class="mc-op-row-val">{{ perf.makeReadyCount || 0 | number }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Operator Rank</span>
                    <span class="mc-op-row-val">{{ perf.rank !== '-' ? '#' + perf.rank : '-' }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Gap to Top</span>
                    <span class="mc-op-row-val mc-val-red">
                      <ng-container *ngIf="(perf.gapToTop || 0) > 0; else noGap1">
                        ▼ -{{ perf.gapToTop | number }} behind
                      </ng-container>
                      <ng-template #noGap1>-</ng-template>
                    </span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">NCR Count</span>
                    <span class="mc-op-row-val cursor-pointer hover:underline text-blue-500"
                      (click)="openNcrModal(perf.empNo, perf.operatorName)">
                      {{ perf.empNo ? (operatorNcrCounts()[perf.empNo] || 0) : 0 }}
                      @if (perf.empNo && operatorNcrCounts()[perf.empNo]) {
                      <span
                        style="font-size: 11px; font-weight: 700; background-color: #fee2e2; color: #b91c1c; padding: 2px 6px; border-radius: 4px; margin-left: 4px;">
                        {{ operatorNcrTotals()[perf.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                      </span>
                      }
                    </span>
                  </div>
                </div>
              </div>
              }
              @if (currentOperatorPerfs().length === 0) {
              <div class="mc-card mc-operator-card">
                <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px;">
                  <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 8px;">
                    <div style="display: flex; align-items: center; gap: 6px; padding-top: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#2563eb" stroke-width="2.5">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span style="font-size: 11px; font-weight: 800; letter-spacing: 0.05em; color: #2563eb; text-transform: uppercase;">Active Operator</span>
                    </div>
                    <div style="font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 12px; border: 1px solid #e2e8f0; color: #475569; background: #f8fafc; text-align: right;">
                      {{ liveShiftDate() || selectedDate() }}<ng-container *ngIf="realtimeShiftName()"> - {{ realtimeShiftName() | uppercase }}</ng-container>
                    </div>
                  </div>
                  <div style="font-size: 26px; font-weight: 800; color: var(--text); letter-spacing: -0.5px;">
                    Unassigned
                  </div>
                </div>
                <div class="mc-op-table">
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Monthly OutPut</span><span
                      class="mc-op-row-val mc-val-green">0</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Avg Hourly OutPut</span><span
                      class="mc-op-row-val mc-val-green">0</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Monthly Make Ready</span><span
                      class="mc-op-row-val">0</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Operator Rank</span><span
                      class="mc-op-row-val">-</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Gap to Top</span><span
                      class="mc-op-row-val mc-val-red">-</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">NCR Count</span><span
                      class="mc-op-row-val">0</span></div>
                </div>
              </div>
              }
            </div>

            <!-- Monthly Summary Card – Machine 1 -->
            <div class="mc-card mc-monthly-card">
              <div class="mc-ms-header">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <span style="font-size: 20px;">Monthly Summary — {{ selectedMonthName() }}</span>
              </div>

              <div class="mc-ms-grid">

                <!-- Total Planned -->
                <div class="mc-ms-cell">
                  <div>
                    <div class="mc-ms-val">{{ monthlyTotalPlanned() | number }}</div>
                    <div class="mc-ms-lbl">Total Planned {{ unitOfMachine() }}</div>
                  </div>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                    class="mc-ms-icon">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                </div>

                <!-- Total Achieved -->
                <div class="mc-ms-cell" style="position: relative;">
                  <div style="display: flex; flex-direction: column;">
                    <div class="mc-ms-val mc-val-green">{{ monthlyTotalAchieved() | number }}</div>
                    <div class="mc-ms-lbl">Total Achieved</div>
                    <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px; color: #64748b;">
                      <span style="font-weight: 800; font-size: 25px;">{{ avgHourlyOutput() | number }}</span>
                      <span style="font-size: 15px;">Avg Hourly Output</span>
                    </div>
                  </div>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                    class="mc-ms-icon">
                    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                    <path d="M22 12A10 10 0 0 0 12 2v10z" />
                  </svg>
                  <div
                    style="position: absolute; top: 12px; right: 12px; font-size: 25px; font-weight: 700; color: #16a34a; background: #dcfce7; padding: 2px 6px; border-radius: 12px;">
                    {{ monthlyAchievementPct() }}%
                  </div>
                </div>

                <!-- Total Make Ready -->
                <div class="mc-ms-cell">
                  <div>
                    <div class="mc-ms-val mc-val-blue">{{ monthlyTotalMakeReady() | number }}</div>
                    <div class="mc-ms-lbl">Total Make Ready</div>
                  </div>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                    class="mc-ms-icon">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>

                <!-- Best Operator -->
                <div class="mc-ms-cell mc-ms-best"
                  style="justify-content: center; padding-top: 16px; padding-bottom: 16px;">
                  <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 24px; width: 100%;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <span class="mc-ms-trophy" style="font-size: 32px;">🏆</span>
                      <div style="display: flex; flex-direction: column; align-items: flex-start;">
                        <span class="mc-ms-best-name mc-val-blue" style="line-height: 0.95;">{{
                          getFirstName(bestOperator()?.operatorName) || '—' }}</span>
                        <span class="mc-ms-best-lbl" style="margin-top: 2px;">Best Operator</span>
                      </div>
                    </div>
                    <div style="display: flex; flex-direction: column; align-items: flex-start; padding-left: 4px;"
                      *ngIf="bestOperator()">
                      <div style="display: flex; align-items: center; gap: 16px;">
                        <span class="mc-ms-best-name mc-val-green" style="line-height: 0.95;">{{
                          bestOperator()?.machineTotalOutput || 0 | number }}</span>
                        <div
                          style="display: flex; flex-direction: column; align-items: center; justify-content: center; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; padding: 4px 12px; min-width: 44px;">
                          <span style="font-size: 16px; font-weight: 800; color: #2563eb; line-height: 1;">{{
                            bestOperator()?.makeReadyCount || 0 }}</span>
                          <span
                            style="font-size: 11px; font-weight: 800; color: #64748b; line-height: 1; margin-top: 4px;">MR</span>
                        </div>
                      </div>
                      <div style="display: flex; align-items: center; gap: 4px; margin-top: 2px; color: #bb3219;">
                        <span style="font-weight: 800; font-size: 30px;">{{ bestOperatorAvgHourlyOutput() | number
                          }}</span>
                        <span style="font-size: 15px;">Avg Hourly Output</span>
                      </div>
                      <div style="display: flex; align-items: center; gap: 8px; margin-top: 4px; color: #475569; flex-wrap: wrap;">
                        <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 14px;" (click)="openNcrModal(bestOperator()?.empNo || '', bestOperator()?.operatorName || '')">
                          IR: <strong>{{ getOperatorIrCount(bestOperator()?.empNo) }}</strong> | CC: <strong>{{ getOperatorCcCount(bestOperator()?.empNo) }}</strong>
                        </span>
                        @if (bestOperator()?.empNo && operatorNcrCounts()[bestOperator()!.empNo]) {
                        <span style="font-size: 11px; font-weight: 700; background-color: #fee2e2; color: #b91c1c; padding: 2px 6px; border-radius: 4px;">
                          {{ operatorNcrTotals()[bestOperator()!.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                        </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Top Runners Up -->
                <div class="mc-ms-cell" style="display: flex; flex-direction: column; justify-content: stretch; padding: 16px 20px; height: 100%; grid-column: span 2;">
                  <div style="font-size: 15px; font-weight: 800; color: var(--text-muted); text-transform: uppercase; margin-bottom: 12px; padding: 0 4px;">
                    Top Runners Up
                  </div>
                  
                  <div style="display: grid; grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1.5fr 1.5fr 1fr; padding: 0 16px 12px; font-size: 13px; font-weight: 700; color: var(--text-muted); align-items: center; border-bottom: 1px solid var(--border); margin-bottom: 12px; width: 100%;">
                    <div>Operator</div>
                    <div style="text-align: center; color: #16a34a;">Output</div>
                    <div style="text-align: center; color: #2563eb;">Make Ready</div>
                    <div style="text-align: center; color: #dc2626;">IR</div>
                    <div style="text-align: center; color: #dc2626;">CC</div>
                    <div style="text-align: center;">NCR Value</div>
                    <div style="text-align: center;">Avg Output</div>
                    <div style="text-align: center; color: #dc2626;">Gap to Top</div>
                  </div>

                  <div style="display: flex; flex-direction: column; flex: 1; width: 100%;">
                    @for (runner of topRunnersUp(); track runner.operatorName; let last = $last) {
                    <div style="display: grid; grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1.5fr 1.5fr 1fr; align-items: center; background: var(--surface); border: 1px solid var(--border); border-radius: 12px; padding: 12px 16px; margin-bottom: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.04);">
                      <div style="display: flex; align-items: center; gap: 12px;">
                        <div style="width: 36px; height: 36px; background: #eff6ff; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #2563eb; font-weight: 700; font-size: 15px;">
                          #{{ runner.rank }}
                        </div>
                        <div style="display: flex; flex-direction: column;">
                          <span style="font-size: 15px; font-weight: 700; color: var(--text);">{{ getFirstName(runner.operatorName) }}</span>
                        </div>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span style="font-size: 17px; font-weight: 700; color: #16a34a;">{{ runner.machineTotalOutput || 0 | number }}</span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span style="font-size: 17px; font-weight: 700; color: #2563eb;">{{ runner.makeReadyCount || 0 }}</span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 17px; color: #dc2626;" (click)="openNcrModal(runner.empNo, runner.operatorName)">
                          {{ getOperatorIrCount(runner.empNo) }}
                        </span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 17px; color: #dc2626;" (click)="openNcrModal(runner.empNo, runner.operatorName)">
                          {{ getOperatorCcCount(runner.empNo) }}
                        </span>
                      </div>
                      
                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        @if (runner.empNo && operatorNcrCounts()[runner.empNo]) {
                          <span style="background: #fee2e2; color: #991b1b; padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 600;">
                            {{ operatorNcrTotals()[runner.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                          </span>
                        }
                        @else {
                          <span style="font-size: 14px; font-weight: 600; color: var(--text-muted);">-</span>
                        }
                      </div>

                      <div style="display: flex; flex-direction: row; align-items: baseline; justify-content: center; gap: 4px;">
                        <span style="font-size: 17px; font-weight: 700; color: var(--text);">{{ runner.machineAvgHourlyOutput || 0 | number }}</span>
                        <span style="font-size: 12px; font-weight: 600; color: var(--text-muted);">/ hr</span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
                        <span style="font-size: 17px; font-weight: 700; color: #dc2626;" *ngIf="runner.gapToTop > 0">-{{ runner.gapToTop | number }}</span>
                        <span style="font-size: 17px; font-weight: 700; color: var(--text-muted);" *ngIf="!runner.gapToTop || runner.gapToTop <= 0">-</span>
                      </div>
                    </div>
                    }
                  </div>
                  @if (topRunnersUp().length === 0) {
                  <div style="font-size: 14px; color: var(--text-muted); font-style: italic; padding: 12px 4px;">No other
                    operators found.</div>
                  }
                </div>

              </div>
            </div>

          </div><!-- /mc-bottom-row machine 1 -->

        </div><!-- /mc-dashboard -->
      </div><!-- /mc-content -->

    </div><!-- /mc-diecut-panel--left -->

    <!-- Vertical divider -->
    <div class="mc-diecut-divider"></div>

    <!-- ═══════════════ RIGHT PANEL – Machine 2 ═══════════════ -->
    <div class="mc-diecut-panel mc-diecut-panel--right">

      <!-- Panel header -->
      <div class="mc-diecut-panel-header">
        <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
          <h2 class="mc-dash-machine-name" style="font-size: 20px;">{{ selectedMachineName2() | uppercase }}</h2>
          <span class="mc-dash-status-badge" [class.mc-status-operational]="machineStatus2() === 'operational'"
            [class.mc-status-make-ready]="machineStatus2() === 'make ready'"
            [class.mc-status-idle]="machineStatus2() === 'idle'" [class.mc-status-hold]="machineStatus2() === 'hold'"
            [class.mc-status-maintenance]="machineStatus2() === 'maintenance'">
            {{ (machineStatus2() || 'UNKNOWN') | uppercase }}
          </span>
          <span *ngIf="realtimeShiftName2()" class="mc-dash-status-badge"
            style="border: 1.5px solid #cbd5e1; color: #475569; background: rgba(203, 213, 225, 0.2);">
            {{ realtimeShiftName2() | uppercase }} - {{ liveShiftDate2() || today }}
          </span>
        </div>
      </div>

      <!-- ── KPI Cards Row ────────────────────── -->
      <div class="mc-content">
        <div class="mc-dashboard">

          <div class="mc-kpi-row">

            <!-- Daily Goal Achievement -->
            <div class="mc-kpi-card mc-goal-card" [class.exceeded-blink]="machineStatus2() === 'make ready' && isTimerExceeded(makeReadyTimerStr2())">
              <div class="mc-goal-title">Daily Goal Achievement</div>
              <div class="mc-goal-body mc-goal-body--centered">
                <div class="mc-donut-wrap">
                  <svg viewBox="0 0 80 80" class="mc-donut">
                    <circle cx="40" cy="40" r="32" class="mc-donut-track" />
                    <circle cx="40" cy="40" r="32" class="mc-donut-fill" stroke-dasharray="201.06"
                      [attr.stroke-dashoffset]="donutDashOffset2()" transform="rotate(-90 40 40)" />
                  </svg>
                  <div class="mc-donut-center">
                    <div class="mc-donut-pct">{{ goalAchievementPct2() }}%</div>
                    <div class="mc-donut-sub">Target</div>
                  </div>
                </div>

                <!-- Make Ready Timer -->
                <div *ngIf="machineStatus2() === 'make ready'" class="mc-mr-timer-container" [class.exceeded]="isTimerExceeded(makeReadyTimerStr2())">
                  <div class="mc-mr-timer-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span>MAKE READY TIMER</span>
                    <span class="mc-mr-timer-status-dot" [class.running]="makeReadyTimerStatus2() === 'running'"
                      [class.paused]="makeReadyTimerStatus2() === 'paused'" [class.exceeded]="isTimerExceeded(makeReadyTimerStr2())"></span>
                  </div>
                  <div class="mc-mr-timer-val" [class.running]="makeReadyTimerStatus2() === 'running'"
                    [class.paused]="makeReadyTimerStatus2() === 'paused'" [class.exceeded]="isTimerExceeded(makeReadyTimerStr2())">
                    {{ makeReadyTimerStr2() }}
                  </div>
                </div>

                <!-- Operational Timer -->
                <div *ngIf="machineStatus2() === 'operational'" class="mc-mr-timer-container">
                  <div class="mc-mr-timer-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <span>OPERATIONAL TIMER</span>
                    <span class="mc-mr-timer-status-dot" [class.running]="operationalTimerStatus2() === 'running'"
                      [class.paused]="operationalTimerStatus2() === 'paused'"></span>
                  </div>
                  <div class="mc-mr-timer-val" [class.running]="operationalTimerStatus2() === 'running'"
                    [class.paused]="operationalTimerStatus2() === 'paused'">
                    {{ operationalTimerStr2() }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Daily Planned -->
            <div class="mc-kpi-card">
              <div class="mc-kc-title">Daily Planned</div>
              <div class="mc-kc-value">{{ dailyPlanned2() | number }}</div>
              <div class="mc-kc-sub">target {{ unitOfMachine2() }}</div>
            </div>

            <!-- Daily Output -->
            <div class="mc-kpi-card">
              <div class="mc-kc-title">Daily Output</div>
              <div class="mc-kc-value mc-val-green">{{ dailyOutput2() | number }}</div>
              <div class="mc-kc-sub">achieved so far</div>
              <div class="mc-mr-badge">
                <div class="mc-mr-badge-count">{{ makeReadyCount2() }}</div>
                <div class="mc-mr-badge-label">MR</div>
              </div>
            </div>

            <!-- Day Shift -->
            <div class="mc-kpi-card" [class.mc-kpi-card--active]="activeShiftName2()?.toLowerCase() === 'day shift'">
              <div class="mc-shift-hdr">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#f59e0b" stroke-width="2.2">
                  <circle cx="12" cy="12" r="5" />
                  <line x1="12" y1="1" x2="12" y2="3" />
                  <line x1="12" y1="21" x2="12" y2="23" />
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                  <line x1="1" y1="12" x2="3" y2="12" />
                  <line x1="21" y1="12" x2="23" y2="12" />
                </svg>
                <span class="mc-shift-name" [class.expanded]="showAllDayOps2()">
                  Day Shift –
                  @if (dayShiftOperators2().length === 0) {
                  Unassigned
                  } @else {
                  @if (showAllDayOps2()) {
                  {{ getFirstNamesArr(dayShiftOperators2()).join(', ') }}
                  <span class="mc-more-link" (click)="showAllDayOps2.set(false)">(show less)</span>
                  } @else {
                  {{ getFirstNamesArr(dayShiftOperators2()).slice(0, 2).join(', ') }}
                  @if (dayShiftOperators2().length > 2) {
                  <span class="mc-more-link" (click)="showAllDayOps2.set(true)">+{{dayShiftOperators2().length - 2}}
                    more</span>
                  }
                  }
                  }
                </span>
                <span class="mc-active-badge" *ngIf="activeShiftName2()?.toLowerCase() === 'day shift'">Active</span>
              </div>
              <div class="mc-kc-value">{{ dayShift2()?.actualOutput || 0 | number }}</div>
              <div class="mc-kc-sub" style="color: #bb3219; font-weight: 700; font-size: 13px; margin-top: 2px;">Avg: {{
                dayShift2()?.outputAveragePerHour || 0 | number:'1.0-0' }} / hr</div>
              <div class="mc-shift-mr-info">
                <span>MR Time: <strong>{{ getShiftMakeReadyTimeStr(dayShift2()) }}</strong></span>
                <span class="mc-smr-dot">•</span>
                <span>Avg/MR: <strong>{{ getShiftAvgMakeReadyTimeStr(dayShift2()) }}</strong></span>
              </div>
              <div class="mc-mr-badge">
                <div class="mc-mr-badge-count">{{ dayShift2()?.makeReadyCount || 0 }}</div>
                <div class="mc-mr-badge-label">MR</div>
              </div>
            </div>

            <!-- Night Shift -->
            <div class="mc-kpi-card" [class.mc-kpi-card--active]="activeShiftName2()?.toLowerCase() === 'night shift'">
              <div class="mc-shift-hdr">
                <span style="font-size:14px;">🌙</span>
                <span class="mc-shift-name" [class.expanded]="showAllNightOps2()">
                  Night Shift –
                  @if (nightShiftOperators2().length === 0) {
                  Unassigned
                  } @else {
                  @if (showAllNightOps2()) {
                  {{ getFirstNamesArr(nightShiftOperators2()).join(', ') }}
                  <span class="mc-more-link" (click)="showAllNightOps2.set(false)">(show less)</span>
                  } @else {
                  {{ getFirstNamesArr(nightShiftOperators2()).slice(0, 2).join(', ') }}
                  @if (nightShiftOperators2().length > 2) {
                  <span class="mc-more-link" (click)="showAllNightOps2.set(true)">+{{nightShiftOperators2().length - 2}}
                    more</span>
                  }
                  }
                  }
                </span>
                <span class="mc-active-badge" *ngIf="activeShiftName2()?.toLowerCase() === 'night shift'">Active</span>
              </div>
              <div class="mc-kc-value mc-val-blue">{{ nightShift2()?.actualOutput || 0 | number }}</div>
              <div class="mc-kc-sub" style="color: #bb3219; font-weight: 700; font-size: 13px; margin-top: 2px;">Avg: {{
                nightShift2()?.outputAveragePerHour || 0 | number:'1.0-0' }} / hr</div>
              <div class="mc-shift-mr-info">
                <span>MR Time: <strong>{{ getShiftMakeReadyTimeStr(nightShift2()) }}</strong></span>
                <span class="mc-smr-dot">•</span>
                <span>Avg/MR: <strong>{{ getShiftAvgMakeReadyTimeStr(nightShift2()) }}</strong></span>
              </div>
              <div class="mc-mr-badge">
                <div class="mc-mr-badge-count">{{ nightShift2()?.makeReadyCount || 0 }}</div>
                <div class="mc-mr-badge-label">MR</div>
              </div>
            </div>

            <!-- ── Machine 2 Timeline ───────────── -->
            <div class="mc-card mc-timeline-card">
              <div class="mc-tl-header">
                <div class="mc-tl-title">
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  Machine Run Timeline
                  <span class="mc-tl-range" *ngIf="timelineWindow2()">
                    ({{ timelineWindow2()?.start }} - {{ timelineWindow2()?.end }})
                  </span>
                </div>
              </div>

              <div class="mc-tl-bar">
                @for (seg of timelineSegments2(); track seg) {
                <div class="mc-tl-seg {{ seg.class }}" [style.left.%]="seg.left" [style.width.%]="seg.width"
                  [title]="seg.tooltip">
                  {{ seg.label }}
                </div>
                }
              </div>

              <div class="mc-tl-axis">
                @for (tick of timelineAxis2(); track tick) {
                <span>{{ tick }}</span>
                }
              </div>

              <div class="mc-tl-legend">
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-run"></span>
                  <span>Operational</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-mr"></span>
                  <span>Make Ready</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-idle"></span>
                  <span>Idle</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-hold"></span>
                  <span>Hold</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-maintenance"></span>
                  <span>Maintenance</span>
                </div>
                <div class="mc-tl-legend-item">
                  <span class="mc-tl-dot mc-seg-heatcool"></span>
                  <span>Heat/Cool</span>
                </div>
              </div>
            </div>

          </div><!-- /mc-kpi-row -->

          <!-- ── Machine 2 Bottom Row ───────────── -->
          <div class="mc-bottom-row" [class.multiple-ops-layout]="currentOperatorPerfs2().length > 1">

            <div class="mc-operator-cards-wrapper">
              @for (perf of currentOperatorPerfs2(); track perf.operatorName) {
              <div class="mc-card mc-operator-card">
                <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px;">
                  <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 8px;">
                    <div style="display: flex; align-items: center; gap: 6px; padding-top: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#2563eb" stroke-width="2.5">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span style="font-size: 11px; font-weight: 800; letter-spacing: 0.05em; color: #2563eb; text-transform: uppercase;">Active Operator</span>
                    </div>
                    <div style="font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 12px; border: 1px solid #e2e8f0; color: #475569; background: #f8fafc; text-align: right;">
                      {{ liveShiftDate2() || selectedDate() }}<ng-container *ngIf="realtimeShiftName2()"> - {{ realtimeShiftName2() | uppercase }}</ng-container>
                    </div>
                  </div>
                  <div style="font-size: 24px; font-weight: 800; color: var(--text); letter-spacing: -0.5px; line-height: 1.2; overflow-wrap: break-word;">
                    {{ perf.operatorName || 'Unassigned' }}
                  </div>
                </div>
                <div class="mc-op-table">
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Monthly OutPut</span>
                    <span class="mc-op-row-val mc-val-green">{{ perf.machineTotalOutput || 0 | number }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Avg Hourly OutPut</span>
                    <span class="mc-op-row-val mc-val-red">{{ perf.machineAvgHourlyOutput || 0 | number }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Monthly Make Ready</span>
                    <span class="mc-op-row-val">{{ perf.makeReadyCount || 0 | number }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Operator Rank</span>
                    <span class="mc-op-row-val">{{ perf.rank !== '-' ? '#' + perf.rank : '-' }}</span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">Gap to Top</span>
                    <span class="mc-op-row-val mc-val-red">
                      <ng-container *ngIf="(perf.gapToTop || 0) > 0; else noGap2">
                        ▼ -{{ perf.gapToTop | number }} behind
                      </ng-container>
                      <ng-template #noGap2>-</ng-template>
                    </span>
                  </div>
                  <div class="mc-op-row">
                    <span class="mc-op-row-lbl">NCR Count</span>
                    <span class="mc-op-row-val cursor-pointer hover:underline text-blue-500"
                      (click)="openNcrModal(perf.empNo, perf.operatorName)">
                      {{ perf.empNo ? (operatorNcrCounts()[perf.empNo] || 0) : 0 }}
                      @if (perf.empNo && operatorNcrCounts()[perf.empNo]) {
                      <span
                        style="font-size: 11px; font-weight: 700; background-color: #fee2e2; color: #b91c1c; padding: 2px 6px; border-radius: 4px; margin-left: 4px;">
                        {{ operatorNcrTotals()[perf.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                      </span>
                      }
                    </span>
                  </div>
                </div>
              </div>
              }
              @if (currentOperatorPerfs2().length === 0) {
              <div class="mc-card mc-operator-card">
                <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px;">
                  <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 8px;">
                    <div style="display: flex; align-items: center; gap: 6px; padding-top: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#2563eb" stroke-width="2.5">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span style="font-size: 11px; font-weight: 800; letter-spacing: 0.05em; color: #2563eb; text-transform: uppercase;">Active Operator</span>
                    </div>
                    <div style="font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 12px; border: 1px solid #e2e8f0; color: #475569; background: #f8fafc; text-align: right;">
                      {{ liveShiftDate2() || selectedDate() }}<ng-container *ngIf="realtimeShiftName2()"> - {{ realtimeShiftName2() | uppercase }}</ng-container>
                    </div>
                  </div>
                  <div style="font-size: 26px; font-weight: 800; color: var(--text); letter-spacing: -0.5px;">
                    Unassigned
                  </div>
                </div>
                <div class="mc-op-table">
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Monthly OutPut</span><span
                      class="mc-op-row-val mc-val-green">0</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Avg Hourly OutPut</span><span
                      class="mc-op-row-val mc-val-green">0</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Monthly Make Ready</span><span
                      class="mc-op-row-val">0</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Operator Rank</span><span
                      class="mc-op-row-val">-</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">Gap to Top</span><span
                      class="mc-op-row-val mc-val-red">-</span></div>
                  <div class="mc-op-row"><span class="mc-op-row-lbl">NCR Count</span><span
                      class="mc-op-row-val">0</span></div>
                </div>
              </div>
              }
            </div>

            <!-- Monthly Summary Card – Machine 2 -->
            <div class="mc-card mc-monthly-card">
              <div class="mc-ms-header">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <span style="font-size: 20px;">Monthly Summary — {{ selectedMonthName() }}</span>
              </div>

              <div class="mc-ms-grid">

                <!-- Total Planned -->
                <div class="mc-ms-cell">
                  <div>
                    <div class="mc-ms-val">{{ monthlyTotalPlanned2() | number }}</div>
                    <div class="mc-ms-lbl">Total Planned {{ unitOfMachine2() }}</div>
                  </div>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                    class="mc-ms-icon">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                </div>

                <!-- Total Achieved -->
                <div class="mc-ms-cell" style="position: relative;">
                  <div style="display: flex; flex-direction: column;">
                    <div class="mc-ms-val mc-val-green">{{ monthlyTotalAchieved2() | number }}</div>
                    <div class="mc-ms-lbl">Total Achieved</div>
                    <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px; color: #64748b;">
                      <span style="font-weight: 800; font-size: 25px;">{{ avgHourlyOutput2() | number }}</span>
                      <span style="font-size: 15px;">Avg Hourly Output</span>
                    </div>
                  </div>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                    class="mc-ms-icon">
                    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                    <path d="M22 12A10 10 0 0 0 12 2v10z" />
                  </svg>
                  <div
                    style="position: absolute; top: 12px; right: 12px; font-size: 25px; font-weight: 700; color: #16a34a; background: #dcfce7; padding: 2px 6px; border-radius: 12px;">
                    {{ monthlyAchievementPct2() }}%
                  </div>
                </div>

                <!-- Total Make Ready -->
                <div class="mc-ms-cell">
                  <div>
                    <div class="mc-ms-val mc-val-blue">{{ monthlyTotalMakeReady2() | number }}</div>
                    <div class="mc-ms-lbl">Total Make Ready</div>
                  </div>
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                    class="mc-ms-icon">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>

                <!-- Best Operator -->
                <div class="mc-ms-cell mc-ms-best"
                  style="justify-content: center; padding-top: 16px; padding-bottom: 16px;">
                  <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 24px; width: 100%;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <span class="mc-ms-trophy" style="font-size: 32px;">🏆</span>
                      <div style="display: flex; flex-direction: column; align-items: flex-start;">
                        <span class="mc-ms-best-name mc-val-blue" style="line-height: 0.95;">{{
                          getFirstName(bestOperator2()?.operatorName) || '—' }}</span>
                        <span class="mc-ms-best-lbl" style="margin-top: 2px;">Best Operator</span>
                      </div>
                    </div>
                    <div style="display: flex; flex-direction: column; align-items: flex-start; padding-left: 4px;"
                      *ngIf="bestOperator2()">
                      <div style="display: flex; align-items: center; gap: 16px;">
                        <span class="mc-ms-best-name mc-val-green" style="line-height: 0.95;">{{
                          bestOperator2()?.machineTotalOutput || 0 | number }}</span>
                        <div
                          style="display: flex; flex-direction: column; align-items: center; justify-content: center; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; padding: 4px 12px; min-width: 44px;">
                          <span style="font-size: 16px; font-weight: 800; color: #2563eb; line-height: 1;">{{
                            bestOperator2()?.makeReadyCount || 0 }}</span>
                          <span
                            style="font-size: 11px; font-weight: 800; color: #64748b; line-height: 1; margin-top: 4px;">MR</span>
                        </div>
                      </div>
                      <div style="display: flex; align-items: center; gap: 4px; margin-top: 2px; color: #bb3219;">
                        <span style="font-weight: 800; font-size: 30px;">{{ bestOperatorAvgHourlyOutput2() | number
                          }}</span>
                        <span style="font-size: 15px;">Avg Hourly Output</span>
                      </div>
                      <div style="display: flex; align-items: center; gap: 8px; margin-top: 4px; color: #475569; flex-wrap: wrap;">
                        <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 14px;" (click)="openNcrModal(bestOperator2()?.empNo || '', bestOperator2()?.operatorName || '')">
                          IR: <strong>{{ getOperatorIrCount(bestOperator2()?.empNo) }}</strong> | CC: <strong>{{ getOperatorCcCount(bestOperator2()?.empNo) }}</strong>
                        </span>
                        @if (bestOperator2()?.empNo && operatorNcrCounts()[bestOperator2()!.empNo]) {
                        <span style="font-size: 11px; font-weight: 700; background-color: #fee2e2; color: #b91c1c; padding: 2px 6px; border-radius: 4px;">
                          {{ operatorNcrTotals()[bestOperator2()!.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                        </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Top Runners Up -->
                <div class="mc-ms-cell" style="display: flex; flex-direction: column; justify-content: stretch; padding: 16px 20px; height: 100%; grid-column: span 2;">
                  <div style="font-size: 15px; font-weight: 800; color: var(--text-muted); text-transform: uppercase; margin-bottom: 12px; padding: 0 4px;">
                    Top Runners Up
                  </div>
                  
                  <div style="display: grid; grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1.5fr 1.5fr 1fr; padding: 0 16px 12px; font-size: 13px; font-weight: 700; color: var(--text-muted); align-items: center; border-bottom: 1px solid var(--border); margin-bottom: 12px; width: 100%;">
                    <div>Operator</div>
                    <div style="text-align: center; color: #16a34a;">Output</div>
                    <div style="text-align: center; color: #2563eb;">Make Ready</div>
                    <div style="text-align: center; color: #dc2626;">IR</div>
                    <div style="text-align: center; color: #dc2626;">CC</div>
                    <div style="text-align: center;">NCR Value</div>
                    <div style="text-align: center;">Avg Output</div>
                    <div style="text-align: center; color: #dc2626;">Gap to Top</div>
                  </div>

                  <div style="display: flex; flex-direction: column; flex: 1; width: 100%;">
                    @for (runner of topRunnersUp2(); track runner.operatorName; let last = $last) {
                    <div style="display: grid; grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1.5fr 1.5fr 1fr; align-items: center; background: var(--surface); border: 1px solid var(--border); border-radius: 12px; padding: 12px 16px; margin-bottom: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.04);">
                      <div style="display: flex; align-items: center; gap: 12px;">
                        <div style="width: 36px; height: 36px; background: #eff6ff; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #2563eb; font-weight: 700; font-size: 15px;">
                          #{{ runner.rank }}
                        </div>
                        <div style="display: flex; flex-direction: column;">
                          <span style="font-size: 15px; font-weight: 700; color: var(--text);">{{ getFirstName(runner.operatorName) }}</span>
                        </div>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span style="font-size: 17px; font-weight: 700; color: #16a34a;">{{ runner.machineTotalOutput || 0 | number }}</span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span style="font-size: 17px; font-weight: 700; color: #2563eb;">{{ runner.makeReadyCount || 0 }}</span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 17px; color: #dc2626;" (click)="openNcrModal(runner.empNo, runner.operatorName)">
                          {{ getOperatorIrCount(runner.empNo) }}
                        </span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 17px; color: #dc2626;" (click)="openNcrModal(runner.empNo, runner.operatorName)">
                          {{ getOperatorCcCount(runner.empNo) }}
                        </span>
                      </div>
                      
                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        @if (runner.empNo && operatorNcrCounts()[runner.empNo]) {
                          <span style="background: #fee2e2; color: #991b1b; padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 600;">
                            {{ operatorNcrTotals()[runner.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                          </span>
                        }
                        @else {
                          <span style="font-size: 14px; font-weight: 600; color: var(--text-muted);">-</span>
                        }
                      </div>

                      <div style="display: flex; flex-direction: row; align-items: baseline; justify-content: center; gap: 4px;">
                        <span style="font-size: 17px; font-weight: 700; color: var(--text);">{{ runner.machineAvgHourlyOutput || 0 | number }}</span>
                        <span style="font-size: 12px; font-weight: 600; color: var(--text-muted);">/ hr</span>
                      </div>

                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
                        <span style="font-size: 17px; font-weight: 700; color: #dc2626;" *ngIf="runner.gapToTop > 0">-{{ runner.gapToTop | number }}</span>
                        <span style="font-size: 17px; font-weight: 700; color: var(--text-muted);" *ngIf="!runner.gapToTop || runner.gapToTop <= 0">-</span>
                      </div>
                    </div>
                    }
                  </div>
                  @if (topRunnersUp2().length === 0) {
                  <div style="font-size: 14px; color: var(--text-muted); font-style: italic; padding: 12px 4px;">No other
                    operators found.</div>
                  }
                </div>

              </div>
            </div>

          </div><!-- /mc-bottom-row machine 2 -->

        </div><!-- /mc-dashboard -->
      </div><!-- /mc-content -->

    </div><!-- /mc-diecut-panel--right -->

  </div><!-- /mc-diecut-split -->

  } @else {

  <!-- ═══════════════════════════════════════════════════════════════════════ -->
  <!-- STANDARD SINGLE-MACHINE LAYOUT (non-diecut sections)                  -->
  <!-- ═══════════════════════════════════════════════════════════════════════ -->

  <div class="od-page-header">
    <div>
      <div style="display: flex; align-items: center; gap: 12px; margin-bottom: -2px;">
        <h1 class="mc-dash-machine-name">{{ selectedMachineName() | uppercase }} OPERATIONAL DASHBOARD</h1>
        <span class="mc-dash-status-badge" [class.mc-status-operational]="machineStatus() === 'operational'"
          [class.mc-status-make-ready]="machineStatus() === 'make ready'"
          [class.mc-status-idle]="machineStatus() === 'idle'" [class.mc-status-hold]="machineStatus() === 'hold'"
          [class.mc-status-maintenance]="machineStatus() === 'maintenance'">
          {{ (machineStatus() || 'UNKNOWN') | uppercase }}
        </span>
        <span *ngIf="realtimeShiftName()" class="mc-dash-status-badge"
          style="border: 1.5px solid #cbd5e1; color: #475569; background: rgba(203, 213, 225, 0.2);">
          {{ realtimeShiftName() | uppercase }} - {{ liveShiftDate() || selectedDate() }}
        </span>
      </div>
      <div class="flex gap-4">

        <div style="display: flex; gap: 16px; font-size: 13px; color: var(--text-muted, #888);">
          <span style="display: flex; align-items: center; gap: 4px;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            {{ selectedDate() }}
          </span>
          <span style="display: flex; align-items: center; gap: 4px;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            {{ currentTime }}
          </span>
        </div>
      </div>
    </div>

    <div class="od-date-controls">
      <div class="od-date-group">
        <span class="od-label">DATE</span>
        <input type="date" [ngModel]="selectedDate()" (ngModelChange)="onDateChange($event)"
          class="od-select od-select-sm" style="min-width: 130px; font-family: inherit;">
      </div>

      <!-- Visual divider between date controls and machine selector -->
      <div class="od-controls-divider"></div>

      <!-- Machine selector — scoped to the active section tab -->
      <div class="od-date-group">
        <span class="od-label">MACHINE</span>
        @if (filteredMachines().length > 0) {
        <select [ngModel]="selectedMachineId()" (ngModelChange)="onMachineChange(+$event)"
          class="od-select od-select-machine">
          @for (machine of filteredMachines(); track machine.machineId) {
          <option [ngValue]="machine.machineId">{{ machine.machineName }}</option>
          }
        </select>
        } @else {
        <span class="od-no-machines">No machines</span>
        }
      </div>
    </div>
  </div>

  <!-- ═══ MACHINE OPERATIONAL DASHBOARD ═══════════════════════════════════════ -->
  <div class="mc-content">
    <div class="mc-dashboard">

      <!-- ── KPI Cards Row ─────────────────────────────────────────────── -->
      <div class="mc-kpi-row">

        <!-- Daily Goal Achievement -->
        <div class="mc-kpi-card mc-goal-card" [class.exceeded-blink]="machineStatus() === 'make ready' && isTimerExceeded(makeReadyTimerStr())">
          <div class="mc-goal-title">Daily Goal Achievement</div>
          <div class="mc-goal-body mc-goal-body--centered">
            <div class="mc-donut-wrap">
              <svg viewBox="0 0 80 80" class="mc-donut">
                <circle cx="40" cy="40" r="32" class="mc-donut-track" />
                <circle cx="40" cy="40" r="32" class="mc-donut-fill" stroke-dasharray="201.06"
                  [attr.stroke-dashoffset]="donutDashOffset()" transform="rotate(-90 40 40)" />
              </svg>
              <div class="mc-donut-center">
                <div class="mc-donut-pct">{{ goalAchievementPct() }}%</div>
                <div class="mc-donut-sub">Target</div>
              </div>
            </div>

            <!-- Make Ready Timer -->
            <div *ngIf="machineStatus() === 'make ready'" class="mc-mr-timer-container" [class.exceeded]="isTimerExceeded(makeReadyTimerStr())">
              <div class="mc-mr-timer-label">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>MAKE READY TIMER</span>
                <span class="mc-mr-timer-status-dot" [class.running]="makeReadyTimerStatus() === 'running'"
                  [class.paused]="makeReadyTimerStatus() === 'paused'" [class.exceeded]="isTimerExceeded(makeReadyTimerStr())"></span>
              </div>
              <div class="mc-mr-timer-val" [class.running]="makeReadyTimerStatus() === 'running'"
                [class.paused]="makeReadyTimerStatus() === 'paused'" [class.exceeded]="isTimerExceeded(makeReadyTimerStr())">
                {{ makeReadyTimerStr() }}
              </div>
            </div>

            <!-- Operational Timer -->
            <div *ngIf="machineStatus() === 'operational'" class="mc-mr-timer-container">
              <div class="mc-mr-timer-label">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>OPERATIONAL TIMER</span>
                <span class="mc-mr-timer-status-dot" [class.running]="operationalTimerStatus() === 'running'"
                  [class.paused]="operationalTimerStatus() === 'paused'"></span>
              </div>
              <div class="mc-mr-timer-val" [class.running]="operationalTimerStatus() === 'running'"
                [class.paused]="operationalTimerStatus() === 'paused'">
                {{ operationalTimerStr() }}
              </div>
            </div>
          </div>
        </div>

        <!-- Daily Planned -->
        <div class="mc-kpi-card">
          <div class="mc-kc-title">Daily Planned</div>
          <div class="mc-kc-value">{{ dailyPlanned() | number }}</div>
          <div class="mc-kc-sub">target {{ unitOfMachine() }}</div>
        </div>

        <!-- Daily Output -->
        <div class="mc-kpi-card">
          <div class="mc-kc-title">Daily Output</div>
          <div class="mc-kc-value mc-val-green">{{ dailyOutput() | number }}</div>
          <div class="mc-kc-sub">achieved so far</div>
          <div class="mc-mr-badge">
            <div class="mc-mr-badge-count">{{ makeReadyCount() }}</div>
            <div class="mc-mr-badge-label">MR</div>
          </div>
        </div>

        <!-- Day Shift -->
        <div class="mc-kpi-card" [class.mc-kpi-card--active]="activeShiftName()?.toLowerCase() === 'day shift'">
          <div class="mc-shift-hdr">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#f59e0b" stroke-width="2.2">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
            </svg>
            <span class="mc-shift-name" [class.expanded]="showAllDayOps()">
              Day Shift –
              @if (dayShiftOperators().length === 0) {
              Unassigned
              } @else {
              @if (showAllDayOps()) {
              {{ getFirstNamesArr(dayShiftOperators()).join(', ') }}
              <span class="mc-more-link" (click)="showAllDayOps.set(false)">(show less)</span>
              } @else {
              {{ getFirstNamesArr(dayShiftOperators()).slice(0, 2).join(', ') }}
              @if (dayShiftOperators().length > 2) {
              <span class="mc-more-link" (click)="showAllDayOps.set(true)">+{{dayShiftOperators().length - 2}}
                more</span>
              }
              }
              }
            </span>
            <span class="mc-active-badge" *ngIf="activeShiftName()?.toLowerCase() === 'day shift'">Active</span>
          </div>
          <div class="mc-kc-value">{{ dayShift()?.actualOutput || 0 | number }}</div>
          <div class="mc-kc-sub" style="color: #bb3219; font-weight: 700; font-size: 13px; margin-top: 2px;">Avg: {{
            dayShift()?.outputAveragePerHour || 0 | number:'1.0-0' }} / hr</div>
          <div class="mc-shift-mr-info">
            <span>MR Time: <strong>{{ getShiftMakeReadyTimeStr(dayShift()) }}</strong></span>
            <span class="mc-smr-dot">•</span>
            <span>Avg/MR: <strong>{{ getShiftAvgMakeReadyTimeStr(dayShift()) }}</strong></span>
          </div>
          <div class="mc-mr-badge">
            <div class="mc-mr-badge-count">{{ dayShift()?.makeReadyCount || 0 }}</div>
            <div class="mc-mr-badge-label">MR</div>
          </div>
        </div>

        <!-- Night Shift -->
        <div class="mc-kpi-card" [class.mc-kpi-card--active]="activeShiftName()?.toLowerCase() === 'night shift'">
          <div class="mc-shift-hdr">
            <span style="font-size:14px;">🌙</span>
            <span class="mc-shift-name" [class.expanded]="showAllNightOps()">
              Night Shift –
              @if (nightShiftOperators().length === 0) {
              Unassigned
              } @else {
              @if (showAllNightOps()) {
              {{ getFirstNamesArr(nightShiftOperators()).join(', ') }}
              <span class="mc-more-link" (click)="showAllNightOps.set(false)">(show less)</span>
              } @else {
              {{ getFirstNamesArr(nightShiftOperators()).slice(0, 2).join(', ') }}
              @if (nightShiftOperators().length > 2) {
              <span class="mc-more-link" (click)="showAllNightOps.set(true)">+{{nightShiftOperators().length - 2}}
                more</span>
              }
              }
              }
            </span>
            <span class="mc-active-badge" *ngIf="activeShiftName()?.toLowerCase() === 'night shift'">Active</span>
          </div>
          <div class="mc-kc-value mc-val-blue">{{ nightShift()?.actualOutput || 0 | number }}</div>
          <div class="mc-kc-sub" style="color: #bb3219; font-weight: 700; font-size: 13px; margin-top: 2px;">Avg: {{
            nightShift()?.outputAveragePerHour || 0 | number:'1.0-0' }} / hr</div>
          <div class="mc-shift-mr-info">
            <span>MR Time: <strong>{{ getShiftMakeReadyTimeStr(nightShift()) }}</strong></span>
            <span class="mc-smr-dot">•</span>
            <span>Avg/MR: <strong>{{ getShiftAvgMakeReadyTimeStr(nightShift()) }}</strong></span>
          </div>
          <div class="mc-mr-badge">
            <div class="mc-mr-badge-count">{{ nightShift()?.makeReadyCount || 0 }}</div>
            <div class="mc-mr-badge-label">MR</div>
          </div>
        </div>

        <!-- ── Machine Run Timeline ─────────────────────────────────────── -->
        <div class="mc-card mc-timeline-card">
          <div class="mc-tl-header">
            <div class="mc-tl-title">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              Machine Run Timeline
              <span class="mc-tl-range" *ngIf="timelineWindow()">
                ({{ timelineWindow()?.start }} - {{ timelineWindow()?.end }})
              </span>
            </div>
          </div>

          <div class="mc-tl-bar">
            @for (seg of timelineSegments(); track seg) {
            <div class="mc-tl-seg {{ seg.class }}" [style.left.%]="seg.left" [style.width.%]="seg.width"
              [title]="seg.tooltip">
              {{ seg.label }}
            </div>
            }
          </div>

          <div class="mc-tl-axis">
            @for (tick of timelineAxis(); track tick) {
            <span>{{ tick }}</span>
            }
          </div>

          <div class="mc-tl-legend">
            <div class="mc-tl-legend-item">
              <span class="mc-tl-dot mc-seg-run"></span>
              <span>Operational</span>
            </div>
            <div class="mc-tl-legend-item">
              <span class="mc-tl-dot mc-seg-mr"></span>
              <span>Make Ready</span>
            </div>
            <div class="mc-tl-legend-item">
              <span class="mc-tl-dot mc-seg-idle"></span>
              <span>Idle</span>
            </div>
            <div class="mc-tl-legend-item">
              <span class="mc-tl-dot mc-seg-hold"></span>
              <span>Hold</span>
            </div>
            <div class="mc-tl-legend-item">
              <span class="mc-tl-dot mc-seg-maintenance"></span>
              <span>Maintenance</span>
            </div>
            <div class="mc-tl-legend-item">
              <span class="mc-tl-dot mc-seg-heatcool"></span>
              <span>Heat/Cool</span>
            </div>
          </div>
        </div>

      </div><!-- /mc-kpi-row -->

      <!-- ── Bottom Row: Operator + Monthly Summary ─────────────────── -->
      <div class="mc-bottom-row" [class.multiple-ops-layout]="currentOperatorPerfs().length > 1">

        <div class="mc-operator-cards-wrapper">
          <!-- Current Operator Cards -->
          @for (perf of currentOperatorPerfs(); track perf.operatorName) {
          <div class="mc-card mc-operator-card">
            <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px;">
              <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 8px;">
                <div style="display: flex; align-items: center; gap: 6px; padding-top: 4px;">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#2563eb" stroke-width="2.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <span style="font-size: 11px; font-weight: 800; letter-spacing: 0.05em; color: #2563eb; text-transform: uppercase;">Active Operator</span>
                </div>
                <div style="font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 12px; border: 1px solid #e2e8f0; color: #475569; background: #f8fafc; text-align: right;">
                  {{ liveShiftDate() || selectedDate() }}<ng-container *ngIf="realtimeShiftName()"> - {{ realtimeShiftName() | uppercase }}</ng-container>
                </div>
              </div>
              <div style="font-size: 24px; font-weight: 800; color: var(--text); letter-spacing: -0.5px; line-height: 1.2; overflow-wrap: break-word;">
                {{ perf.operatorName || 'Unassigned' }}
              </div>
            </div>
            <div class="mc-op-table">
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Monthly OutPut</span>
                <span class="mc-op-row-val mc-val-green">{{ perf.machineTotalOutput || 0 | number }}</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Avg Hourly OutPut</span>
                <span class="mc-op-row-val mc-val-red">{{ perf.machineAvgHourlyOutput || 0 | number }}</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Monthly Make Ready</span>
                <span class="mc-op-row-val">{{ perf.makeReadyCount || 0 | number }}</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Operator Rank</span>
                <span class="mc-op-row-val">{{ perf.rank !== '-' ? '#' + perf.rank : '-' }}</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Gap to Top</span>
                <span class="mc-op-row-val mc-val-red">
                  <ng-container *ngIf="(perf.gapToTop || 0) > 0; else noGap">
                    ▼ -{{ perf.gapToTop | number }} behind
                  </ng-container>
                  <ng-template #noGap>-</ng-template>
                </span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">NCR Count</span>
                <span class="mc-op-row-val cursor-pointer hover:underline text-blue-500"
                  (click)="openNcrModal(perf.empNo, perf.operatorName)">
                  {{ perf.empNo ? (operatorNcrCounts()[perf.empNo] || 0) : 0 }}
                  @if (perf.empNo && operatorNcrCounts()[perf.empNo]) {
                  <span
                    style="font-size: 11px; font-weight: 700; background-color: #fee2e2; color: #b91c1c; padding: 2px 6px; border-radius: 4px; margin-left: 4px;">
                    {{ operatorNcrTotals()[perf.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                  </span>
                  }
                </span>
              </div>
            </div>
          </div>
          }
          @if (currentOperatorPerfs().length === 0) {
          <div class="mc-card mc-operator-card">
            <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px;">
              <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 8px;">
                <div style="display: flex; align-items: center; gap: 6px; padding-top: 4px;">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#2563eb" stroke-width="2.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <span style="font-size: 11px; font-weight: 800; letter-spacing: 0.05em; color: #2563eb; text-transform: uppercase;">Active Operator</span>
                </div>
                <div style="font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 12px; border: 1px solid #e2e8f0; color: #475569; background: #f8fafc; text-align: right;">
                  {{ liveShiftDate() || selectedDate() }}<ng-container *ngIf="realtimeShiftName()"> - {{ realtimeShiftName() | uppercase }}</ng-container>
                </div>
              </div>
              <div style="font-size: 26px; font-weight: 800; color: var(--text); letter-spacing: -0.5px;">
                Unassigned
              </div>
            </div>
            <div class="mc-op-table">
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Monthly OutPut</span>
                <span class="mc-op-row-val mc-val-green">0</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Avg Hourly OutPut</span>
                <span class="mc-op-row-val mc-val-green">0</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Monthly Make Ready</span>
                <span class="mc-op-row-val">0</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Operator Rank</span>
                <span class="mc-op-row-val">-</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">Gap to Top</span>
                <span class="mc-op-row-val mc-val-red">-</span>
              </div>
              <div class="mc-op-row">
                <span class="mc-op-row-lbl">NCR Count</span>
                <span class="mc-op-row-val">0</span>
              </div>
            </div>
          </div>
          }
        </div>

        <!-- Monthly Summary Card -->
        <div class="mc-card mc-monthly-card">
          <div class="mc-ms-header">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            <span style="font-size: 20px;">Monthly Summary — {{ selectedMonthName() }}</span>
          </div>

          <div class="mc-ms-grid">

            <!-- Total Planned imp -->
            <div class="mc-ms-cell">
              <div>
                <div class="mc-ms-val">{{ monthlyTotalPlanned() | number }}</div>
                <div class="mc-ms-lbl">Total Planned {{ unitOfMachine() }}</div>
              </div>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                class="mc-ms-icon">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </div>

            <!-- Total Achieved -->
            <div class="mc-ms-cell" style="position: relative;">
              <div style="display: flex; flex-direction: column;">
                <div class="mc-ms-val mc-val-green">{{ monthlyTotalAchieved() | number }}</div>
                <div class="mc-ms-lbl">Total Achieved</div>
                <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;  color: #64748b;">
                  <span style="font-weight: 800; font-size: 25px;">{{ avgHourlyOutput() | number }}</span>
                  <span style="font-size: 15px;">Avg Hourly Output</span>
                </div>
              </div>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                class="mc-ms-icon">
                <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                <path d="M22 12A10 10 0 0 0 12 2v10z" />
              </svg>
              <div
                style="position: absolute; top: 12px; right: 12px; font-size: 25px; font-weight: 700; color: #16a34a; background: #dcfce7; padding: 2px 6px; border-radius: 12px;">
                {{ monthlyAchievementPct() }}%
              </div>
            </div>

            <!-- Total Make Ready -->
            <div class="mc-ms-cell">
              <div>
                <div class="mc-ms-val mc-val-blue">{{ monthlyTotalMakeReady() | number }}</div>
                <div class="mc-ms-lbl">Total Make Ready</div>
              </div>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"
                class="mc-ms-icon">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>



            <!-- Best Operator -->
            <div class="mc-ms-cell mc-ms-best"
              style="justify-content: center; padding-top: 16px; padding-bottom: 16px;">
              <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 24px; width: 100%;">

                <div style="display: flex; align-items: center; gap: 12px;">
                  <span class="mc-ms-trophy" style="font-size: 32px;">🏆</span>
                  <div style="display: flex; flex-direction: column; align-items: flex-start;">
                    <span class="mc-ms-best-name mc-val-blue" style="line-height: 0.95;">{{
                      getFirstName(bestOperator()?.operatorName) || '—' }}</span>
                    <span class="mc-ms-best-lbl" style="margin-top: 2px;">Best Operator</span>
                  </div>
                </div>

                <div style="display: flex; flex-direction: column; align-items: flex-start; padding-left: 4px;"
                  *ngIf="bestOperator()">
                  <div style="display: flex; align-items: center; gap: 16px;">
                    <span class="mc-ms-best-name mc-val-green" style="line-height: 0.95;">{{
                      bestOperator()?.machineTotalOutput || 0 | number }}</span>
                    <div
                      style="display: flex; flex-direction: column; align-items: center; justify-content: center; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; padding: 4px 12px; min-width: 44px;">
                      <span style="font-size: 16px; font-weight: 800; color: #2563eb; line-height: 1;">{{
                        bestOperator()?.makeReadyCount || 0 }}</span>
                      <span
                        style="font-size: 11px; font-weight: 800; color: #64748b; line-height: 1; margin-top: 4px;">MR</span>
                    </div>
                  </div>
                  <!-- <span class="mc-ms-best-lbl" style="margin-top: 2px;">Monthly Output</span> -->
                  <!-- <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;  color: #64748b;">
                    <span style="font-weight: 800; font-size: 20px;">{{ bestOperatorAvgDailyOutput() | number }}</span>
                    <span style="font-size: 25px;"></span>
                    <span style="font-size: 15px;">Avg Daily Output</span>
                  </div> -->
                  <div style="display: flex; align-items: center; gap: 8px; margin-top: 4px; color: #475569; flex-wrap: wrap;">
                    <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 14px;" (click)="openNcrModal(bestOperator()?.empNo || '', bestOperator()?.operatorName || '')">
                      IR: <strong>{{ getOperatorIrCount(bestOperator()?.empNo) }}</strong> | CC: <strong>{{ getOperatorCcCount(bestOperator()?.empNo) }}</strong>
                    </span>
                    @if (bestOperator()?.empNo && operatorNcrCounts()[bestOperator()!.empNo]) {
                    <span style="font-size: 11px; font-weight: 700; background-color: #fee2e2; color: #b91c1c; padding: 2px 6px; border-radius: 4px;">
                      {{ operatorNcrTotals()[bestOperator()!.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                    </span>
                    }
                  </div>
                </div>

              </div>
            </div>

            <!-- Top Runners Up -->
            <div class="mc-ms-cell" style="display: flex; flex-direction: column; justify-content: stretch; padding: 16px 20px; height: 100%; grid-column: span 2;">
              <div style="font-size: 15px; font-weight: 800; color: var(--text-muted); text-transform: uppercase; margin-bottom: 12px; padding: 0 4px;">
                Top Runners Up
              </div>
              
              <div style="display: grid; grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1.5fr 1.5fr 1fr; padding: 0 16px 12px; font-size: 13px; font-weight: 700; color: var(--text-muted); align-items: center; border-bottom: 1px solid var(--border); margin-bottom: 12px; width: 100%;">
                <div>Operator</div>
                <div style="text-align: center; color: #16a34a;">Output</div>
                <div style="text-align: center; color: #2563eb;">Make Ready</div>
                <div style="text-align: center; color: #dc2626;">IR</div>
                <div style="text-align: center; color: #dc2626;">CC</div>
                <div style="text-align: center;">NCR Value</div>
                <div style="text-align: center;">Avg Output</div>
                <div style="text-align: center; color: #dc2626;">Gap to Top</div>
              </div>

              <div style="display: flex; flex-direction: column; flex: 1; width: 100%;">
                @for (runner of topRunnersUp(); track runner.operatorName; let last = $last) {
                <div style="display: grid; grid-template-columns: 2fr 1fr 1fr 0.8fr 0.8fr 1.5fr 1.5fr 1fr; align-items: center; background: var(--surface); border: 1px solid var(--border); border-radius: 12px; padding: 12px 16px; margin-bottom: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.04);">
                  <div style="display: flex; align-items: center; gap: 12px;">
                    <div style="width: 36px; height: 36px; background: #eff6ff; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #2563eb; font-weight: 700; font-size: 15px;">
                      #{{ runner.rank }}
                    </div>
                    <div style="display: flex; flex-direction: column;">
                      <span style="font-size: 15px; font-weight: 700; color: var(--text);">{{ getFirstName(runner.operatorName) }}</span>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <span style="font-size: 17px; font-weight: 700; color: #16a34a;">{{ runner.machineTotalOutput || 0 | number }}</span>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <span style="font-size: 17px; font-weight: 700; color: #2563eb;">{{ runner.makeReadyCount || 0 }}</span>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 17px; color: #dc2626;" (click)="openNcrModal(runner.empNo, runner.operatorName)">
                      {{ getOperatorIrCount(runner.empNo) }}
                    </span>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <span class="cursor-pointer hover:underline text-blue-500" style="font-weight: 700; font-size: 17px; color: #dc2626;" (click)="openNcrModal(runner.empNo, runner.operatorName)">
                      {{ getOperatorCcCount(runner.empNo) }}
                    </span>
                  </div>
                  
                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    @if (runner.empNo && operatorNcrCounts()[runner.empNo]) {
                      <span style="background: #fee2e2; color: #991b1b; padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 600;">
                        {{ operatorNcrTotals()[runner.empNo] || 0 | currency:'LKR ':'symbol':'1.0-0' }}
                      </span>
                    }
                    @else {
                      <span style="font-size: 14px; font-weight: 600; color: var(--text-muted);">-</span>
                    }
                  </div>

                  <div style="display: flex; flex-direction: row; align-items: baseline; justify-content: center; gap: 4px;">
                    <span style="font-size: 17px; font-weight: 700; color: var(--text);">{{ runner.machineAvgHourlyOutput || 0 | number }}</span>
                    <span style="font-size: 12px; font-weight: 600; color: var(--text-muted);">/ hr</span>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
                    <span style="font-size: 17px; font-weight: 700; color: #dc2626;" *ngIf="runner.gapToTop > 0">-{{ runner.gapToTop | number }}</span>
                    <span style="font-size: 17px; font-weight: 700; color: var(--text-muted);" *ngIf="!runner.gapToTop || runner.gapToTop <= 0">-</span>
                  </div>
                </div>
                }
              </div>
              @if (topRunnersUp().length === 0) {
              <div style="font-size: 14px; color: var(--text-muted); font-style: italic; padding: 12px 4px;">No other
                operators found.</div>
              }
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

  }<!-- /@if isDiecut -->

  @if(ncrModalOpen()){
  <div id="ncr-modal" tabindex="-1" aria-hidden="true"
    class="fixed inset-0 z-[105] flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
    <div
      class="relative p-4 w-fit max-w-[95vw] min-w-[50vw] mx-auto bg-white rounded-lg shadow-lg max-h-[90vh] flex flex-col">
      <div class="flex items-center justify-between p-4 border-b rounded-t">
        <h3 class="text-lg font-semibold text-gray-900 flex items-center">
          NCR Details - {{ selectedNcrOperatorName() }}
        </h3>
        <button type="button" (click)="closeNcrModal()"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <div class="p-4 overflow-y-auto max-h-[calc(90vh-100px)]">
        <table class="table w-auto border text-sm text-left text-gray-500 mx-auto">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 border-b sticky top-0 z-10 shadow-sm">
            <tr>
              <th scope="col" class="px-4 py-3">NCR Number</th>
              <th scope="col" class="px-4 py-3">Date</th>
              <th scope="col" class="px-4 py-3">Type</th>
              <th scope="col" class="px-4 py-3">Job Number</th>
              <th scope="col" class="px-4 py-3">Description</th>
              <th scope="col" class="px-4 py-3 text-right">Value</th>
              <th scope="col" class="px-4 py-3 text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            @for (ncr of operatorNcrDetails(); track ncr.ncrId) {
            <tr class="bg-white border-b hover:bg-gray-50">
              <td class="px-4 py-2 font-medium text-gray-900 whitespace-nowrap">{{ ncr.ncrNumber }}</td>
              <td class="px-4 py-2 whitespace-nowrap">{{ ncr.ncrDate | date: 'yyyy-MM-dd' }}</td>
              <td class="px-4 py-2 whitespace-nowrap">{{ ncr.ncrType }}</td>
              <td class="px-4 py-2 whitespace-nowrap">{{ ncr.jobNumber }}</td>
              <td class="px-4 py-2 max-w-xs truncate" [title]="ncr.joDescription">{{ ncr.joDescription }}</td>
              <td class="px-4 py-2 whitespace-nowrap text-right font-medium">{{ ncr.ncrValue ? (ncr.ncrValue |
                currency:'LKR ':'symbol':'1.2-2') : '-' }}</td>
              <td class="px-4 py-2 whitespace-nowrap text-center">
                <span class="px-2 py-1 rounded text-xs" [ngClass]="{
                  'bg-green-100 text-green-800': ncr.status === 'approved',
                  'bg-yellow-100 text-yellow-800': ncr.status === 'pending',
                  'bg-red-100 text-red-800': ncr.status === 'rejected'
                }">{{ ncr.status | titlecase }}</span>
              </td>
            </tr>
            }
            @if (operatorNcrDetails().length === 0) {
            <tr>
              <td colspan="7" class="px-4 py-8 text-center text-gray-500">No NCR details found.</td>
            </tr>
            }
          </tbody>
          <tfoot *ngIf="operatorNcrDetails().length > 0" class="bg-gray-50 text-gray-900 font-bold border-t">
            <tr>
              <td colspan="5" class="px-4 py-3 text-right">Total NCR Value:</td>
              <td class="px-4 py-3 text-right">{{ totalNcrValue() | currency:'LKR ':'symbol':'1.2-2' }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
  }

</div>